import safeStringifyMod from 'json-stringify-safe';
import _ from 'lodash';

export function safeStringify(obj) {
    let resultStr = '';

    try {
        resultStr = safeStringifyMod(obj);
    } catch (e) {
        resultStr = e.toString()
    }
    return resultStr;
}

export const removeNonDigitCharacters = string => _.replace(string, /\D/g, '');

export const removeAllHyphens = (str) => {
    return _.replace(_.trim(str), /-/g, '');
};

/**
 * This function cleans the passed object by removing keys
 * which have value as empty string.
 */
export const cleanObjectByRemovingEmptyStringKeys = (obj) => {
    Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object') {
            cleanObjectByRemovingEmptyStringKeys(obj[key]);
        } else if (obj[key] === '') {
            delete obj[key];
        }
    });
    return obj;
};

/**
 * This function will verify the input payload with a default provided by argument
 * required payload with types. Currently only int and string are supported,
 * but more types could be easily added by providing the validation function
 */
export function verifyParameters(logger, requiredFlatParams, jsonPayload){

    try {
        _.forEach(requiredFlatParams, (validationType, key) => {
            const paramValue = _.get(jsonPayload, key);

            if (!_.isNil(paramValue)){
                switch (validationType) {
                    case 'int':
                        if (!_.isInteger(paramValue)) {
                            logger('warn', `${key} is not of type ${validationType}`);
                        }
                        break;
                    case 'object':
                        if (!_.isObject(paramValue) || _.isEmpty(paramValue)) {
                            logger('warn', `${key} is not of type ${validationType}`);
                        }
                        break;
                    default:
                    case 'string':
                        if (!_.isString(paramValue)) {
                            logger('warn', `${key} is not of type ${validationType}`);
                        }
                }
            } else {
                logger('warn', `This parameter does not exist ${key}`);
            }
        });
    } catch (error) {
        logger('warn', `verifyParameters error=${error}`);
    }
}

/**
 * Concatenate street number and name into one string
 * @param streetNumber
 * @param streetName
 * @returns concatenated string or empty string if both parameters are empty strings
 */
export function concatenateStreetNumberAndName(streetNumber, streetName) {
    return _.trim(`${(streetNumber) ? streetNumber : ''} ${(streetName) ? streetName : ''}`)   ;
}
